import { Controller } from "@hotwired/stimulus"

// components/verifica/EfficaciaAtto.js: `value` è il JSON del campo nascosto `valore` (disabilitato = undefined, la
// chiave non va nel corpo); v = value || {stato: "vigente"} (il valore di partenza è già doc.efficacia).
// - la spunta: {stato: "in_attesa", condizione: "", punto: "", citazione: ""}, tolta {stato: "vigente", riscontro: {}};
// - i campi della sospensione: {...v, campo: testo}; quelli del riscontro: {...v, riscontro: {...v.riscontro, campo}};
// - in attesa: la spiegazione e i tre campi; tolta la spunta a un atto salvato in attesa (`sospeso`): il riscontro.
// Il <details> resta aperto o chiuso come l'ha lasciato l'operatore anche quando la riga è riletta con morph.
export default class extends Controller {
  static targets = ["valore", "spunta", "attesa", "sospensione", "riscontro"]
  static values = { sospeso: Boolean }

  connect() {
    this.mostra()
  }

  riletto(event) {
    if (event.target === this.element) this.mostra()
  }

  attributo(event) {
    if (event.target === this.element && event.detail.attributeName === "open") event.preventDefault()
  }

  get value() {
    if (this.valoreTarget.disabled) return undefined
    try {
      const v = JSON.parse(this.valoreTarget.value)
      return v && typeof v === "object" ? v : undefined
    } catch {
      return undefined
    }
  }

  get v() {
    return this.value || { stato: "vigente" }
  }

  spunta(event) {
    this.cambia(event.target.checked ? { stato: "in_attesa", condizione: "", punto: "", citazione: "" } : { stato: "vigente", riscontro: {} })
  }

  campo(event) {
    this.cambia({ ...this.v, [event.target.dataset.campo]: event.target.value })
  }

  prova(event) {
    const v = this.v
    this.cambia({ ...v, riscontro: { ...v.riscontro, [event.target.dataset.prova]: event.target.value } })
  }

  cambia(valore) {
    this.valoreTarget.disabled = false
    this.valoreTarget.value = JSON.stringify(valore)
    this.mostra()
  }

  mostra() {
    const v = this.v
    const pending = v.stato === "in_attesa"
    const resuming = this.sospesoValue && !pending
    this.spuntaTarget.checked = pending
    this.attesaTarget.hidden = !pending
    this.sospensioneTargets.forEach((el) => { el.hidden = !pending })
    this.riscontroTargets.forEach((el) => { el.hidden = !resuming })
    this.element.querySelectorAll("[data-campo]").forEach((el) => this.scrivi(el, v[el.dataset.campo]))
    this.element.querySelectorAll("[data-prova]").forEach((el) => this.scrivi(el, v.riscontro?.[el.dataset.prova]))
  }

  // value={x || ''}: il campo mostra il valore (cambiato solo se diverso, il cursore resta dov'è)
  scrivi(el, x) {
    const testo = x || ""
    if (el.tagName === "SELECT" && ![...el.options].some((o) => o.value === testo)) {
      el.value = ""
    } else if (el.value !== testo) {
      el.value = testo
    }
  }
}
